export default __webpack_public_path__ + "media/icons/angle_bold_right_black-08510a01.svg";